module.exports = __webpack_public_path__ + "img/mvl-calc-red.b40d5b31.jpg";